var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"receipt-wrapper",class:{ 'is-print-show': _vm.show }},[_c('prescribing-info',{ref:"prescribing",attrs:{"data":_vm.prescribingInfo},on:{"error":_vm.onError}}),_c('drug-info',{attrs:{"data":_vm.drugInfo}}),_c('doctor-info',{ref:"doctor",attrs:{"data":_vm.doctorInfo},on:{"error":_vm.onError}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }